import styled from "styled-components";

export const Alert = styled.div`
  padding: 40px 10px;

  border: 2px rgba(${({ variant }) => variantEnums.getVariant(variant) },0.5) solid;
  border-radius: 5px;
  background-color: rgba(${({ variant }) => variantEnums.getVariant(variant)},0.1);
`

const variantEnums = {
  "info": "154,90,207",
  "danger": "255,0,0",
  "success": "0,155,0",
  "warn" : "200,150,0",
  getVariant(variant) {
    if (this.hasOwnProperty(variant)) return this[variant]
    return this.info // default
  }
}



